import { z } from "zod";
const OpenURLElementSchema = z.object({
    "open-url": z.string()
});
const OpenURLExternalElementSchema = z.object({
    "open-url-external": z.string()
});
const OpenDeepLinkElementSchema = z.object({
    "open-deep-link": z.string()
});
const CloseElementSchema = z.object({
    close: z.string()
});
const CustomElementSchema = z.object({
    custom: z.string()
});
const RestoreElementSchema = z.object({
    restore: z.string()
});
const VarElementSchema = z.object({
    var: z.string()
});
const VideoElementSchema = z.object({
    video: z.string()
});
const ContainerElementSchema = z.object({
    container: z.string()
});
const PurchaseElementSchema = z.object({
    purchase: z.string()
});
export const PaywallElementSchema = z.union([
    OpenURLElementSchema,
    OpenURLExternalElementSchema,
    OpenDeepLinkElementSchema,
    CloseElementSchema,
    CustomElementSchema,
    RestoreElementSchema,
    VarElementSchema,
    VideoElementSchema,
    ContainerElementSchema,
    PurchaseElementSchema
]);
export const attributeNames = [
    "open-url",
    "open-url-external",
    "open-deep-link",
    "close",
    "restore",
    "var",
    "video",
    "purchase",
    "custom"
];
